module.exports = __webpack_public_path__ + "img/shop-photo2.60779ff5.jpg";